import constants from "../../constants";
import { AppState } from "../../contexts/App";
import { clearAdIntent } from "../../hooks/AdIntent";
import { sitePath } from "../../hooks/SitePath";
import { Site, createNewSite } from "../../model/site";
import { keepoInternalAnalyticsService } from "../../services/analytics";
import { api } from "../../services/api";
import { uuidv4 } from "../../utils/uuid";
import { AdNiche } from "./niches";

type StartFirstKeepoDeps = {
  /** Opens the new Keepo as the one being edited. */
  onStart: (site: Site, appState: Partial<AppState>) => void;
};

// A new account with no Keepo: marks the first steps as done (once) and opens a new Keepo on the name screen.
// From an ad page (`niche`: a niche's page or the generic one, which is also a niche, with no category): the
// niche's category (none for the generic page, whose name screen then asks for it) and straight on to "Criar com IA"
// after the name. `null` is a plain sign up (no ad page): the usual name screen. Returns where to go next.
export function startFirstKeepo(niche: AdNiche | null, { onStart }: StartFirstKeepoDeps): string {
  // Call and forget: the event goes out only once it's really completed
  api
    .completeOnboarding()
    .then(() => api.getUser())
    .then(user => keepoInternalAnalyticsService.notifyOnboardingCompletedEvent(user))
    .catch(() => undefined);

  clearAdIntent();

  if (constants.freeKeeposLimit <= 0) {
    return "/subscription/features";
  }

  const siteId = uuidv4();
  onStart(
    { ...createNewSite(), category: niche?.category ?? "" },
    {
      editingSiteId: siteId,
      editingSiteModified: false,
      published: false,
      editingSiteDisabled: false,
      editingSiteSubscription: { type: "FREE" },
    }
  );

  // the Keepo's own address (the old /editor/... would need the new Keepo already open to find it)
  return sitePath(siteId, niche ? "/editor/title?flow=ads" : "/editor/title");
}
